import { createStyles } from 'antd-style';

export const useShipmentTemplateButtonsStyles = createStyles(
  ({ css, token }) => ({
    marginSm: css`
      @media (min-width: ${token.screenMDMin}px) {
        gap: ${token.paddingXS}px;
      }
    `,
  })
);
